import Poster from './Poster'

const NotStarted = () => {
  return (<Poster headline="Not started yet." copy="Stay tuned!" allowVideo={true} />)
}

export default NotStarted
